export function buildRegisterFormData({
     firstName,
     middleName,
     lastName,
     phoneCode,
     phoneNumber,
     birthDate,
     email,
     password,
     passwordConfirmation,
     accountRole,
     majorId,
     academicDegreeId,
}) {
     const formData = new FormData();
     formData.append('first_name', firstName);
     if (middleName) formData.append('middle_name', middleName);
     formData.append('last_name', lastName);
     formData.append('phone_code', phoneCode);
     formData.append('phone', phoneNumber);
     formData.append('birth_date', birthDate);
     formData.append('email', email);
     formData.append('password', password);
     formData.append('password_confirmation', passwordConfirmation);
     formData.append('account_role', accountRole);
     if (majorId) formData.append('major_id', majorId);
     if (academicDegreeId) formData.append('academic_degree_id', academicDegreeId);

     return formData;
}